/**
 * Chapter021.js — Electrical Equipment Policy (OHSE 021)
 * Migrated from SWMS Platform Chapter021.tsx → JavaScript
 *
 * Static policy text only — company name is the only variable.
 *
 * Props:
 *   companyName {string}  from companyInfo.name
 */

export default function Chapter021({ companyName }) {
  const cn = companyName || '[Company Name]';
  const Co = () => <span className="font-semibold text-[#c9a84c]">{cn}</span>;

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <p className="text-xs font-semibold text-[#c9a84c] uppercase tracking-widest mb-1">OHSE 021</p>
        <h2 className="text-xl font-bold text-[#1a1a2e] uppercase tracking-wide">Electrical Equipment</h2>
      </div>

      <div className="bg-white border border-[#e0dbd0] rounded-lg overflow-hidden">
        <div className="px-4 py-2.5 bg-[#f0ede6]">
          <h3 className="text-sm font-semibold text-[#1a1a2e] uppercase tracking-wide">
            Electrical Equipment Policy
          </h3>
          <p className="text-xs text-gray-500 mt-0.5">
            Compliance requirements for electrical equipment on site
          </p>
        </div>
        <div className="p-6 space-y-4 text-sm text-[#1a1a2e] leading-relaxed">
          <p>
            All electrical work carried out by <Co /> shall be in accordance with AS3012 and AS3000
            and all other relevant codes of practice, standards and legislation.
          </p>

          <p>
            <Co /> maintains an Electrical Equipment Register that details all electrical equipment
            brought onto site and records test and tag information for each item.
          </p>

          <p>
            All electrical equipment is inspected and tested and tagged in accordance with the relevant
            Australian Standard prior to initial use and at regular intervals thereafter.
          </p>
        </div>
      </div>
    </div>
  );
}
